export default __webpack_public_path__ + "static/media/downArrow.a7e93641.svg";